export default {
	"planDispatch": {
		"mapPlanning": "map planning",
		"addRoute": "Additional waybill",
		"IdlingRate": "Empty rate",
		"pPunctuality": "On time rate",
		"confirmScheduling": "Confirm Scheduling",
		"autoLine": "Automatic route planning",
		"operatingTips": "Operation Tips",
		"onlyOneRouter": "Only one dispatch record can be selected"
	},
	"transportOrderInfo": {
		"needDelivery": "delivery required"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/planDispatch/planDispatch.js